import { useState, useEffect, Suspense } from 'react';
import { motion } from 'framer-motion';
// import Fragment from './Fragment';
import LandingPageNav from '../components/landingPage/LandingPageNav';
import ThreeScene from '../components/landingPage/ThreeScene';
import { Outlet, useLocation } from 'react-router-dom';

const LandingPage = (props) => {

  const { siteData, setActiveToolTip, currentItem, setCurrentItem } = props;
  const [items, setItems] = useState(siteData?.fragments?.entries ? siteData.fragments.entries : []);
  const [artefacts, setArtefacts] = useState(siteData?.artefacts?.entries ? siteData.artefacts.entries : []);
  const [selectedLayer, setSelectedLayer] = useState({});
	const [selectedLocation, setSelectedLocation] = useState({});
	
	const location = useLocation();
	const { pathname } = location;

  useEffect(() => {
    if (siteData?.fragments?.entries) {
      setItems(siteData.fragments.entries);
    }
    if (siteData?.artefacts?.entries) {
      setArtefacts(siteData.artefacts?.entries);
    }
    if (location.pathname === '/') {
      setActiveToolTip('Click the items on the map to find out more!');
    }
	}, [siteData.fragments, siteData.artefacts, setActiveToolTip, location.pathname,]);

  return (
    <Suspense fallback={null}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="view--landing-page"
      >
        <ThreeScene
          {...props}
          items={items}
          currentItem={currentItem}
          setCurrentItem={setCurrentItem}
          selectedLayer={selectedLayer}
          selectedLocation={selectedLocation}
          artefacts={artefacts}
        />
        {
          pathname === '/' &&
          <LandingPageNav
            {...props}
            selectedLayer={selectedLayer}
            setSelectedLayer={setSelectedLayer}
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
          />
        }
        <Outlet />
      </motion.div>
    </Suspense>
  )
}

export default LandingPage;